import { customIconFileNames } from "../../map-editor/components/panels/MapPanel/entityEditModalConfig";

const GENERATED_PREFIX = "locapp-generated://";
const NONE_VALUE = "locapp-none://thumbnail";

export const TEMPLATE_THUMBNAIL_COLORS = [
  "#154C79",
  "#1E6AA8",
  "#5B3F86",
  "#0F766E",
  "#1D4ED8",
  "#7C3AED",
  "#B45309",
  "#BE185D",
];

export const TEMPLATE_THUMBNAIL_ICON_OPTIONS = customIconFileNames.map((fileName) => ({
  key: fileName,
  src: `/icons/${fileName}`,
}));

export const DEFAULT_TEMPLATE_THUMBNAIL = {
  mode: "generated",
  iconKey: TEMPLATE_THUMBNAIL_ICON_OPTIONS[0]?.key || "location.png",
  backgroundColor: TEMPLATE_THUMBNAIL_COLORS[0],
};

const sanitizeColor = (value) => {
  const candidate = String(value || "").trim();
  return /^#([0-9a-fA-F]{6})$/.test(candidate)
    ? candidate.toUpperCase()
    : DEFAULT_TEMPLATE_THUMBNAIL.backgroundColor;
};

const sanitizeIconKey = (value) => {
  const candidate = String(value || "").trim();
  return TEMPLATE_THUMBNAIL_ICON_OPTIONS.some((icon) => icon.key === candidate)
    ? candidate
    : DEFAULT_TEMPLATE_THUMBNAIL.iconKey;
};

export const serializeGeneratedThumbnailUrl = ({ iconKey, backgroundColor } = {}) => {
  const icon = sanitizeIconKey(iconKey);
  const color = sanitizeColor(backgroundColor);
  const encodedIcon = encodeURIComponent(icon);
  const encodedColor = encodeURIComponent(color);
  return `${GENERATED_PREFIX}?icon=${encodedIcon}&bg=${encodedColor}`;
};

export const serializeNoThumbnailUrl = () => NONE_VALUE;

export const parseThumbnailFromTemplate = (template) => {
  const raw = String(
    template?.thumbnailURL || template?.thumbnailUrl || ""
  ).trim();

  if (!raw) {
    return { mode: "fallback" };
  }

  if (raw === NONE_VALUE) {
    return { mode: "none" };
  }

  if (raw.startsWith(GENERATED_PREFIX)) {
    const queryPart = raw.slice(GENERATED_PREFIX.length);
    const params = new URLSearchParams(queryPart.startsWith("?") ? queryPart.slice(1) : queryPart);
    return {
      mode: "generated",
      iconKey: sanitizeIconKey(params.get("icon")),
      backgroundColor: sanitizeColor(params.get("bg")),
    };
  }

  return {
    mode: "image",
    imageUrl: raw,
  };
};

export const createDefaultGeneratedThumbnail = () => ({
  mode: "generated",
  iconKey: DEFAULT_TEMPLATE_THUMBNAIL.iconKey,
  backgroundColor: DEFAULT_TEMPLATE_THUMBNAIL.backgroundColor,
});

export const createNoThumbnail = () => ({ mode: "none" });

export const normalizeGeneratedThumbnail = (thumbnail) => ({
  mode: "generated",
  iconKey: sanitizeIconKey(thumbnail?.iconKey),
  backgroundColor: sanitizeColor(thumbnail?.backgroundColor),
});
